import { Authenticator, AuthenticatorProps } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify/utils';
import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import LogoIcon from '@/assets/logo.svg';
import { strings } from '@/constants/strings';
import { urls } from '@/constants/urls';
import { useAuthStatus } from '@/hooks/use-auth-status';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { UnauthenticatedLayout } from '@/layouts/unauthenticated-layout';

import './styles.css';

const authenticatorFormFields: AuthenticatorProps['formFields'] = {
  signIn: {
    username: {
      placeholder: 'Enter email address',
      label: 'Email address',
      isRequired: true,
    },
    password: {
      placeholder: 'Enter password',
      label: 'Password',
      isRequired: true,
    },
  },
  forgotPassword: {
    username: {
      placeholder: 'Enter email address',
      label: 'Email address',
      isRequired: true,
    },
  },
};

//TODO: investigate whether this page can be customised more. Amplify seems to limit this, but maybe could be done by some sort of wrapping/overlay/extension?
I18n.putVocabulariesForLanguage('en', {
  'Setup TOTP': 'Set up sign-in code',
  'Code *':
    "Install Microsoft Authenticator on your phone, and use the scanner in the app to scan the QR code. Put the code it gives you in below. \n You'll need to put in a code from the app each time you sign in. ",
});

export const LoginPage: FC = () => {
  const { isAuthenticated, cognitoAuthStatus } = useAuthStatus();

  // Update document title
  useDocumentTitle();

  if (isAuthenticated) {
    return <Navigate to={urls.home} />;
  }

  return (
    <UnauthenticatedLayout>
      {cognitoAuthStatus === 'authenticated' ? (
        <BeatLoader color="white" />
      ) : (
        <div className="flex flex-col items-center gap-10 text-white">
          <div className="flex h-16 w-full flex-row items-center justify-center gap-4">
            <LogoIcon className="h-11 w-11" />
            <div className="text-4xl font-extrabold">
              {strings.sidebar.title}
            </div>
          </div>
          <div className="flex min-h-96 flex-col justify-center">
            <Authenticator hideSignUp formFields={authenticatorFormFields} />
          </div>
          <div className="text-sm">
            Not a member?{' '}
            <a
              className="leading-normal font-semibold underline"
              href="https://www.caresurround.co.uk/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Contact CareSurround to join
            </a>
          </div>
        </div>
      )}
    </UnauthenticatedLayout>
  );
};
